/*
 *
 * Transactions Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 03-Mar-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_TRANSACTIONS_TAB: '@@Transactions/get_transactions_tab',
  DO_GET_AUTHORIZED_TRANSACTIONS: '@@Transactions/get_authorized_transactions',
  DO_GET_TRANSACTIONS_AGGREGATES: '@@Transactions/get_transactions_aggregates',
  DO_GET_TRANSACTION_TAB_DETAILS: '@@Transactions/get_transaction_tab_details',
  DO_GET_ACCOUNTED_TRANSACTIONS: '@@Transactions/get_accounted_transactions',
  DO_GET_AUTHORIZED_TRANSACTION_TABS_DETAILS: '@@Transactions/get_authorized_transaction_tabs_details',
  DO_GET_ACCOUNTED_TRANSACTION_TABS_DETAILS: '@@Transactions/get_accounted_transaction_tabs_details',
  DO_GET_AUTHORIZED_TRANSACTION_DETAILS_NOTE: '@@Transactions/get_authorized_transaction_details_note',
  DO_EDIT_AUTHORIZED_TRANSACTION_DETAILS_NOTE: '@@Transactions/edit_authorized_transaction_details_note',
  DO_GET_DOWNLOAD_AUTHORIZED_TRANSACTION_DETAILS: '@@Transactions/get_download_authorized_transaction_details',
  DO_GET_DOWNLOAD_ACCOUNTED_TRANSACTION_DETAILS: '@@Transactions/get_download_accounted_transaction_details',
  DO_GET_START_DOWNLOAD_AUTHORIZED_TRANSACTIONS: '@@Transactions/get_start_download_authorized_transactions',
  DO_POLLING_STATUS_DOWNLOAD_AUTHORIZED_TRANSACTIONS: '@@Transactions/polling_status_download_authorized_transactions',
  DO_GET_DOWNLOAD_AUTHORIZED_TRANSACTIONS: '@@Transactions/get_download_authorized_transactions',
  DO_GET_START_DOWNLOAD_ACCOUNTED_TRANSACTIONS: '@@Transactions/get_start_download_accounted_transactions',
  DO_POLLING_STATUS_DOWNLOAD_ACCOUNTED_TRANSACTIONS: '@@Transactions/polling_status_download_accounted_transactions',
  DO_GET_DOWNLOAD_ACCOUNTED_TRANSACTIONS: '@@Transactions/get_download_accounted_transactions',
  DO_CHECK_REFUNDABLE: '@@Transactions/check_refundable',
  DO_TRANSACTION_REFUND: '@@Transactions/transaction_refund',
  RESET_TRANSACTION_REFUND: '@@Transactions/reset_transaction_refund',
  DO_GET_TERMINALS: '@@Transactions/get_terminals',
  RESET_TRANSACTIONS_STATE: '@@Transactions/reset_transactions_state',
  DO_SEARCH_ANNOTATIONS: '@@Transactions/do_search_annotations',
  DO_SET_AUTHORIZED_REQUEST_PARAMS: '@@Transactions/do_set_authorized_request_params',
  DO_SET_ACCOUNTED_REQUEST_PARAMS: '@@Transactions/do_set_accounted_request_params',
  DO_GET_REFUND_MODULE: '@@Transactions/do_get_refund_module',

  // @generator action:route:type
  ...createRequestTypes('@@Transactions', 'GET_TRANSACTIONS_TAB'),
  ...createRequestTypes('@@Transactions', 'GET_AUTHORIZED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'GET_TRANSACTIONS_AGGREGATES'),
  ...createRequestTypes('@@Transactions', 'GET_ACCOUNTED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'GET_TRANSACTION_TAB_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_AUTHORIZED_TRANSACTION_TABS_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_ACCOUNTED_TRANSACTION_TABS_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_ACCOUNTED_TRANSACTION_TAB_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_AUTHORIZED_TRANSACTION_DETAILS_NOTE'),
  ...createRequestTypes('@@Transactions', 'EDIT_AUTHORIZED_TRANSACTION_DETAILS_NOTE'),
  ...createRequestTypes('@@Transactions', 'GET_DOWNLOAD_AUTHORIZED_TRANSACTION_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_DOWNLOAD_ACCOUNTED_TRANSACTION_DETAILS'),
  ...createRequestTypes('@@Transactions', 'GET_START_DOWNLOAD_AUTHORIZED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'POLLING_STATUS_DOWNLOAD_AUTHORIZED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'GET_DOWNLOAD_AUTHORIZED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'GET_START_DOWNLOAD_ACCOUNTED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'POLLING_STATUS_DOWNLOAD_ACCOUNTED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'GET_DOWNLOAD_ACCOUNTED_TRANSACTIONS'),
  ...createRequestTypes('@@Transactions', 'CHECK_REFUNDABLE'),
  ...createRequestTypes('@@Transactions', 'TRANSACTION_REFUND'),
  ...createRequestTypes('@@Transactions', 'GET_TERMINALS'),
  ...createRequestTypes('@@Transactions', 'SEARCH_ANNOTATIONS'),
  ...createRequestTypes('@@Transactions', 'GET_REFUND_MODULE')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name getTransactionsTab
 * @return {object} - The action object
 */
export const getTransactionsTab = new MakeRequest('Transactions', 'get_transactions_tab')
/** @action request
 * * Insert a description
 * @name getAuthorizedTransactions
 * @return {object} - The action object
 */
export const getAuthorizedTransactions = new MakeRequest('Transactions', 'get_authorized_transactions')
/** @action request
 * * Insert a description
 * @name getAccountedTransactions
 * @return {object} - The action object
 */
export const getAccountedTransactions = new MakeRequest('Transactions', 'get_accounted_transactions')
/** @action request
 * * Insert a description
 * @name getTransactionsAggregates
 * @return {object} - The action object
 */
export const getTransactionsAggregates = new MakeRequest('Transactions', 'get_transactions_aggregates')
/** @action request
 * * Insert a description
 * @name getAuthorizedTransactionTabsDetails
 * @return {object} - The action object
 */
export const getAuthorizedTransactionTabsDetails = new MakeRequest('Transactions', 'get_authorized_transaction_tabs_details')
/** @action request
 * * Insert a description
 * @name getAccountedTransactionTabsDetails
 * @return {object} - The action object
 */
export const getAccountedTransactionTabsDetails = new MakeRequest('Transactions', 'get_accounted_transaction_tabs_details')
/** @action request
 * * Insert a description
 * @name getAuthorizedTransactionDetailsNote
 * @return {object} - The action object
 */
export const getAuthorizedTransactionDetailsNote = new MakeRequest('Transactions', 'get_authorized_transaction_details_note')
/** @action request
 * * Insert a description
 * @name editAuthorizedTransactionDetailsNote
 * @return {object} - The action object
 */
export const editAuthorizedTransactionDetailsNote = new MakeRequest('Transactions', 'edit_authorized_transaction_details_note')
/** @action request
 * * Insert a description
 * @name getDownloadAuthorizedTransactionDetails
 * @return {object} - The action object
 */
export const getDownloadAuthorizedTransactionDetails = new MakeRequest('Transactions', 'get_download_authorized_transaction_details')
/** @action request
 * * Insert a description
 * @name getDownloadAccountedTransactionDetails
 * @return {object} - The action object
 */
export const getDownloadAccountedTransactionDetails = new MakeRequest('Transactions', 'get_download_accounted_transaction_details')
/** @action request
 * * Insert a description
 * @name getStartDownloadAuthorizedTransactions
 * @return {object} - The action object
 */
export const getStartDownloadAuthorizedTransactions = new MakeRequest('Transactions', 'get_start_download_authorized_transactions')
/** @action request
 * * Insert a description
 * @name pollingStatusDownloadAuthorizedTransactions
 * @return {object} - The action object
 */
export const pollingStatusDownloadAuthorizedTransactions = new MakeRequest('Transactions', 'polling_status_download_authorized_transactions')
/** @action request
 * * Insert a description
 * @name getDownloadAuthorizedTransactions
 * @return {object} - The action object
 */
export const getDownloadAuthorizedTransactions = new MakeRequest('Transactions', 'get_download_authorized_transactions')
/** @action request
 * * Insert a description
 * @name getStartDownloadAccountedTransactions
 * @return {object} - The action object
 */
export const getStartDownloadAccountedTransactions = new MakeRequest('Transactions', 'get_start_download_accounted_transactions')
/** @action request
 * * Insert a description
 * @name pollingStatusDownloadAccountedTransactions
 * @return {object} - The action object
 */
export const pollingStatusDownloadAccountedTransactions = new MakeRequest('Transactions', 'polling_status_download_accounted_transactions')
/** @action request
 * * Insert a description
 * @name getDownloadAccountedTransactions
 * @return {object} - The action object
 */
export const getDownloadAccountedTransactions = new MakeRequest('Transactions', 'get_download_accounted_transactions')
/** @action request
 * * Insert a description
 * @name getTerminals
 * @return {object} - The action object
 */
export const getTerminals = new MakeRequest('Transactions', 'get_terminals')
/** @action
 * * Insert a description
 * @name checkRefundable
 * @return {object} - The payload object
 */
export const checkRefundable = new MakeRequest('Transactions', 'check_refundable')
/** @action request
 * * Insert a description
 * @name transactionRefund
 * @return {object} - The action object
 */
export const transactionRefund = new MakeRequest('Transactions', 'transaction_refund')
/** @action request
 * * Insert a description
 * @name searchAnnotations
 * @return {object} - The action object
 */
export const searchAnnotations = new MakeRequest('Transactions', 'search_annotations')
/** @action request
 * * Insert a description
 * @name getRefundModule
 * @return {object} - The action object
 */
export const getRefundModule = new MakeRequest('Transactions', 'get_refund_module')
// @generator action:route
/** @action
 * * Insert a description
 * @name doGetTransactionsTab
 * @return {object} - The payload object
 */
export const doGetTransactionsTab = (payload) => createAction(actionTypes.DO_GET_TRANSACTIONS_TAB, { payload })
/** @action
 * * Insert a description
 * @name doGetAuthorizedTransactions
 * @return {object} - The payload object
 */
export const doGetAuthorizedTransactions = (payload) => createAction(actionTypes.DO_GET_AUTHORIZED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetAccountedTransactions
 * @return {object} - The payload object
 */
export const doGetAccountedTransactions = (payload) => createAction(actionTypes.DO_GET_ACCOUNTED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetTransactionsAggregates
 * @return {object} - The payload object
 */
export const doGetTransactionsAggregates = (payload) => createAction(actionTypes.DO_GET_TRANSACTIONS_AGGREGATES, { payload })
/** @action
 * * Insert a description
 * @name doGetAuthorizedTransactionTabsDetails
 * @return {object} - The payload object
 */
export const doGetAuthorizedTransactionTabsDetails = (payload) => createAction(actionTypes.DO_GET_AUTHORIZED_TRANSACTION_TABS_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetAuthorizedTransactionTabsDetails
 * @return {object} - The payload object
 */
export const doGetAccountedTransactionTabsDetails = (payload) => createAction(actionTypes.DO_GET_ACCOUNTED_TRANSACTION_TABS_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetAuthorizedTransactionDetailsNote
 * @return {object} - The payload object
 */
export const doGetAuthorizedTransactionDetailsNote = (payload) => createAction(actionTypes.DO_GET_AUTHORIZED_TRANSACTION_DETAILS_NOTE, { payload })
/** @action
 * * Insert a description
 * @name doEditAuthorizedTransactionDetailsNote
 * @return {object} - The payload object
 */
export const doEditAuthorizedTransactionDetailsNote = (payload) => createAction(actionTypes.DO_EDIT_AUTHORIZED_TRANSACTION_DETAILS_NOTE, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadAuthorizedTransactionDetails
 * @return {object} - The payload object
 */
export const doGetDownloadAuthorizedTransactionDetails = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_AUTHORIZED_TRANSACTION_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadAccountedTransactionDetails
 * @return {object} - The payload object
 */
export const doGetDownloadAccountedTransactionDetails = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_ACCOUNTED_TRANSACTION_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadAuthorizedTransactions
 * @return {object} - The payload object
 */
export const doGetStartDownloadAuthorizedTransactions = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_AUTHORIZED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadAuthorizedTransactions
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadAuthorizedTransactions = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_AUTHORIZED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadAuthorizedTransactions
 * @return {object} - The payload object
 */
export const doGetDownloadAuthorizedTransactions = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_AUTHORIZED_TRANSACTIONS, { payload })/** @action
 * * Insert a description
 * @name doGetStartDownloadAccountedTransactions
 * @return {object} - The payload object
 */
export const doGetStartDownloadAccountedTransactions = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_ACCOUNTED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadAccountedTransactions
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadAccountedTransactions = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_ACCOUNTED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadAccountedTransactions
 * @return {object} - The payload object
 */
export const doGetDownloadAccountedTransactions = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_ACCOUNTED_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doCheckRefundable
 * @return {object} - The payload object
 */
export const doCheckRefundable = payload => createAction(actionTypes.DO_CHECK_REFUNDABLE, { payload })
/** @action
 * * Insert a description
 * @name doTransactionRefund
 * @return {object} - The payload object
 */
export const doTransactionRefund = (payload) => createAction(actionTypes.DO_TRANSACTION_REFUND, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name resetTransactionRefund
 * @return {object} - The payload object
 */
export const resetTransactionRefund = () => createAction(actionTypes.RESET_TRANSACTION_REFUND, {})
/** @action
 * * Insert a description
 * @name doGetTerminals
 * @return {object} - The payload object
 */
export const doGetTerminals = (payload) => createAction(actionTypes.DO_GET_TERMINALS, { payload })
/** @action
 * * Reset transactions state when leaving the page
 * @name resetTransactionsState
 * @return {object} - The action object
 */
export const resetTransactionsState = () => createAction(actionTypes.RESET_TRANSACTIONS_STATE)
/** @action
 * * Search annotations based on note payload
 * @name doSearchAnnotations
 * @return {object} - The action object
 */
export const doSearchAnnotations = (payload) => createAction(actionTypes.DO_SEARCH_ANNOTATIONS, { payload })
/**
 * @action
 * * Set authorized request parameters for transactions
 * @name doSetAuthorizedRequestParams
 * @return {object} - The action object
 */
export const doSetAuthorizedRequestParams = (payload) => createAction(actionTypes.DO_SET_AUTHORIZED_REQUEST_PARAMS, { payload })
/**
 * @action
 * * Set authorized request parameters for transactions
 * @name doSetAccountedRequestParams
 * @return {object} - The action object
 */
export const doSetAccountedRequestParams = (payload) => createAction(actionTypes.DO_SET_ACCOUNTED_REQUEST_PARAMS, { payload })
/** @action
 * * Insert a description
 * @name doGetRefundModule
 * @return {object} - The action object
 */
export const doGetRefundModule = (payload) => createAction(actionTypes.DO_GET_REFUND_MODULE, { payload })
